<!--
# -----------------------------------------------------------------------------
# Component: PolicyInsured.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Policy Header -> Insured Tab
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex lg12 md12 xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{ labels.insuredTitle }} Details</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex lg1 md1 xs12>
                    <v-checkbox
                      :disabled="disableInsdRefAE"
                      color="primary"
                      :label="'Auto '"
                      v-model="mainForm.insdRefNoAE"
                      @change="doInsdRefNoAE"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex lg4 md4 xs12>
                    <v-text-field
                      v-model="mainForm.insdRefNo"
                      :label="labels.insdRefNo"
                      :error-messages="errors.collect('insdRefNo')"
                      data-vv-name="insdRefNo"
                      :data-vv-as="labels.insdRefNo"
                      :disabled="disableInsdRefNo"
                      v-validate="valInsdRefNo"
                      @blur="doValInsdStatus"
                    >
                    </v-text-field>
                    <warning v-model="warnInsdRefNo" @ok="doAcceptInsdRefNo">{{ warnInsdRefNoMsg }}</warning>
                  </v-flex>
                  <v-flex lg1 md1 xs12 style="padding-top: 20px !important">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon color="info" v-show="!disableInsdRefAE" v-on="on" @click="doShowInsdRefNo" v-text="'mdi-magnify'"></v-icon>
                      </template>
                      <span>Click to search insured</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="error"
                          v-show="disableInsdRefAE"
                          v-on="on"
                          @click="showChangeInsuredWarn"
                          v-text="'mdi-account-remove'"
                        ></v-icon>
                      </template>
                      <span>Click to remove insured</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex lg3 md3 xs12>
                    <v-radio-group v-model="mainForm.insdStat" :mandatory="true" row :disabled="disabledInsured">
                      <v-radio :label="labels.individual" value="I"></v-radio>
                      <v-radio :label="labels.corporate" value="C"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex lg3 md3 xs12>
                    <v-autocomplete
                      :items="clientTypeList"
                      v-model="mainForm.clientType"
                      :label="labels.clientType"
                      item-text="label"
                      item-value="value"
                      data-vv-name="clientType"
                      :data-vv-as="labels.clientType"
                      :error-messages="errors.collect('clientType')"
                      v-validate="'max:2'"
                      :disabled="disabledInsured"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg12 md12 xs12>
                    <v-layout row wrap v-show="mainForm.insdStat === 'I'">
                      <v-flex lg2 md2 xs12>
                        <v-autocomplete
                          :items="salutationList"
                          v-model="mainForm.titleName"
                          :label="labels.titleName"
                          item-text="label"
                          item-value="value"
                          data-vv-name="titleName"
                          :data-vv-as="labels.titleName"
                          :error-messages="errors.collect('titleName')"
                          v-validate="'max:3'"
                          :disabled="disabledInsured"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex lg4 md4 xs12>
                        <v-text-field
                          v-model="mainForm.insdName1"
                          :label="labels.insdName1"
                          :error-messages="errors.collect('insdName1')"
                          data-vv-name="insdName1"
                          :data-vv-as="labels.insdName1"
                          v-validate="'required|max:60|sanction:' + sanctionName1Error"
                          @change="valSanction(mainForm.insdName1, '', 'sanctionName1Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg3 md3 xs12>
                        <v-text-field
                          v-model="mainForm.insdName2"
                          :label="labels.insdName2"
                          :error-messages="errors.collect('insdName2')"
                          data-vv-name="insdName2"
                          :data-vv-as="labels.insdName2"
                          v-validate="'max:60|sanction:' + sanctionName2Error"
                          @change="valSanction(mainForm.insdName2, '', 'sanctionName2Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg3 md3 xs12>
                        <v-text-field
                          v-model="mainForm.insdName3"
                          :label="labels.insdName3"
                          :error-messages="errors.collect('insdName3')"
                          data-vv-name="insdName3"
                          :data-vv-as="labels.insdName3"
                          v-validate="'max:60|sanction:' + sanctionName3Error"
                          @change="valSanction(mainForm.insdName3, '', 'sanctionName3Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg12 md12 xs12>
                    <v-layout row wrap v-show="mainForm.insdStat === 'C'">
                      <v-flex lg4 md4 xs12>
                        <v-text-field
                          v-model="mainForm.insdName1"
                          :label="labels.insdName1"
                          :error-messages="errors.collect('insdName1')"
                          data-vv-name="insdName1"
                          :data-vv-as="labels.insdName1"
                          v-validate="'required|max:60|sanction:' + sanctionName1Error"
                          @change="valSanction(mainForm.insdName1, '', 'sanctionName1Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg4 md4 xs12>
                        <v-text-field
                          v-model="mainForm.insdName2"
                          :label="labels.insdName2"
                          :error-messages="errors.collect('insdName2')"
                          data-vv-name="insdName2"
                          :data-vv-as="labels.insdName2"
                          v-validate="'max:60|sanction:' + sanctionName2Error"
                          @change="valSanction(mainForm.insdName2, '', 'sanctionName2Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg4 md4 xs12>
                        <v-text-field
                          v-model="mainForm.insdName3"
                          :label="labels.insdName3"
                          :error-messages="errors.collect('insdName3')"
                          data-vv-name="insdName3"
                          :data-vv-as="labels.insdName3"
                          v-validate="'max:60|sanction:' + sanctionName3Error"
                          @change="valSanction(mainForm.insdName3, '', 'sanctionName3Error')"
                          :disabled="disabledInsured"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg6 md6 xs12>
                    <v-text-field
                      v-model="mainForm.occupation"
                      :label="labels.occupation"
                      :error-messages="errors.collect('occupation')"
                      data-vv-name="occupation"
                      :data-vv-as="mainForm.occupation"
                      v-validate="'entry|max:100'"
                      clearable
                    >
                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                        <v-icon color="info" @click="showOccupationHelpList = true" v-text="'mdi-magnify'"></v-icon>
                      </v-slide-x-reverse-transition>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-show="mainForm.insdStat === 'I'">
                  <v-flex xs12>
                    <div class="subheading font-weight-strong teal--text">{{ labels.individualTitle }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-show="mainForm.insdStat === 'I'">
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="nationalityList"
                      v-model="mainForm.nationality"
                      :label="labels.nationality"
                      item-text="label"
                      item-value="value"
                      data-vv-name="nationality"
                      :data-vv-as="labels.nationality"
                      :error-messages="errors.collect('nationality')"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.icNo"
                      :label="labels.icNo"
                      :error-messages="errors.collect('icNo')"
                      data-vv-name="icNo"
                      :data-vv-as="labels.icNo"
                      v-validate="valIcNo"
                      @change="valSanction('', mainForm.icNo, 'sanctionDocNoError')"
                      @blur="doValDupInsdICNo"
                      :disabled="readonlyIndividual"
                    ></v-text-field>
                    <warning v-model="warnIcNoRoc" @ok="doAcceptIcNoRoc">{{ warnIcNoRocMsg }}</warning>
                    <warning v-model="warnBlankIcNoRoc" @ok="doAcceptBlankIcNoRoc">{{ warnBlankIcNoRocMsg }}</warning>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker v-model="mainForm.dob" :label="labels.dob" :disabled="readonlyIndividual"></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-autocomplete
                      :items="genderList"
                      v-model="mainForm.gender"
                      :label="labels.gender"
                      item-text="label"
                      item-value="value"
                      data-vv-name="gender"
                      :data-vv-as="labels.gender"
                      :error-messages="errors.collect('gender')"
                      :disabled="readonlyIndividual"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-show="mainForm.insdStat === 'C'">
                  <v-flex xs12>
                    <div class="subheading font-weight-strong teal--text">{{ labels.corporateTitle }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-show="mainForm.insdStat === 'C'">
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.roc"
                      :label="labels.roc"
                      :error-messages="errors.collect('roc')"
                      data-vv-name="roc"
                      :data-vv-as="labels.roc"
                      v-validate="valRocNo"
                      @blur="doValDupInsdICNo"
                      :disabled="readonlyCorporate"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker v-model="mainForm.gstRegDate" :label="labels.gstRegDate" :disabled="readonlyCorporate"></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.gstRegNo"
                      :label="labels.gstRegNo"
                      :error-messages="errors.collect('gstRegNo')"
                      data-vv-name="gstRegNo"
                      :data-vv-as="labels.gstRegNo"
                      v-validate="'max:20'"
                      :disabled="readonlyCorporate"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="subheading font-weight-strong teal--text">{{ labels.mailingAddTitle }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.insdAddr1"
                      :label="labels.insdAddr1"
                      :error-messages="errors.collect('insdAddr1')"
                      data-vv-name="insdAddr1"
                      :data-vv-as="labels.insdAddr1"
                      v-validate="'max:60'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.insdAddr2"
                      :label="labels.insdAddr2"
                      :error-messages="errors.collect('insdAddr2')"
                      data-vv-name="insdAddr2"
                      :data-vv-as="labels.insdAddr2"
                      v-validate="'max:60'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.insdAddr3"
                      :label="labels.insdAddr3"
                      :error-messages="errors.collect('insdAddr3')"
                      data-vv-name="insdAddr3"
                      :data-vv-as="labels.insdAddr3"
                      v-validate="'max:60'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                    <warning v-model="warnInsdAddr3" @ok="doAcceptInsdAddr3">{{ warnInsdAddr3Msg }}</warning>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.insdAddr4"
                      :label="labels.insdAddr4"
                      :error-messages="errors.collect('insdAddr4')"
                      data-vv-name="insdAddr4"
                      :data-vv-as="labels.insdAddr4"
                      v-validate="'max:60'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.postCode"
                      :label="labels.postCode"
                      v-int-mask="{ intScale: 8 }"
                      :error-messages="errors.collect('postCode')"
                      data-vv-name="postCode"
                      :data-vv-as="labels.postCode"
                      v-validate="valPostCode"
                      :disabled="disabledInsured"
                      @change="fetchAddress(1)"
                    ></v-text-field>
                    <warning v-model="warnPostCode" @ok="doAcceptPostCode">{{ warnPostCodeMsg }}</warning>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="subheading font-weight-strong teal--text">{{ labels.contactInfoTitle }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.mobile"
                      :label="labels.mobile"
                      :error-messages="errors.collect('mobile')"
                      data-vv-name="mobile"
                      :data-vv-as="labels.mobile"
                      v-validate="'max:20'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.telNo1"
                      :label="labels.telNo1"
                      :error-messages="errors.collect('telNo1')"
                      data-vv-name="telNo1"
                      :data-vv-as="labels.telNo1"
                      v-validate="'max:20'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.telNo2"
                      :label="labels.telNo2"
                      :error-messages="errors.collect('telNo2')"
                      data-vv-name="telNo2"
                      :data-vv-as="labels.mobileNo"
                      v-validate="'max:20'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field
                      v-model="mainForm.fax"
                      :label="labels.fax"
                      :error-messages="errors.collect('fax')"
                      data-vv-name="fax"
                      :data-vv-as="labels.fax"
                      v-validate="'max:20'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="mainForm.email"
                      :label="labels.email"
                      :error-messages="errors.collect('email')"
                      data-vv-name="email"
                      :data-vv-as="labels.email"
                      v-validate="'max:50'"
                      :disabled="disabledInsured"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-dialog v-model="showInsdRefNo" width="1280px" persistent>
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      Insured
                      <v-spacer></v-spacer>
                      <v-btn text icon @click="showInsdRefNo = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-flex xs12>
                        <form data-vv-scope="queryInsdRefNoFilterForm">
                          <v-expansion-panels v-model="panel1" multiple>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card>
                                  <v-card-text>
                                    <v-container fluid grid-list-sm>
                                      <v-layout row wrap>
                                        <v-flex lg6 xs12>
                                          <v-text-field
                                            data-vv-scope="queryInsdRefNoFilterForm"
                                            v-model="filters.insdRefNo"
                                            :label="filtersLabel.insdRefNo"
                                            :error-messages="errors.collect('queryInsdRefNoFilterForm.filterInsdRefNo')"
                                            data-vv-name="filterInsdRefNo"
                                            :data-vv-as="filtersLabel.insdRefNo"
                                            v-validate="'entry|max:8'"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12>
                                          <v-text-field
                                            data-vv-scope="queryInsdRefNoFilterForm"
                                            v-model="filters.name1"
                                            :label="filtersLabel.name1"
                                            :error-messages="errors.collect('queryInsdRefNoFilterForm.filterName1')"
                                            data-vv-name="filterName1"
                                            :data-vv-as="filtersLabel.name1"
                                            v-validate="'name|max:60'"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12>
                                          <v-text-field
                                            data-vv-scope="queryInsdRefNoFilterForm"
                                            v-model="filters.icNo"
                                            :label="filtersLabel.icNo"
                                            :error-messages="errors.collect('queryInsdRefNoFilterForm.filterIcNo')"
                                            data-vv-name="filterIcNo"
                                            :data-vv-as="filtersLabel.icNo"
                                            v-validate="'name|max:20'"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex lg6 xs12>
                                          <v-text-field
                                            data-vv-scope="queryInsdRefNoFilterForm"
                                            v-model="filters.coRegNo"
                                            :label="filtersLabel.coRegNo"
                                            :error-messages="errors.collect('queryInsdRefNoFilterForm.filterCoRegNo')"
                                            data-vv-name="filterCoRegNo"
                                            :data-vv-as="filtersLabel.coRegNo"
                                            v-validate="'name|max:20'"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions right>
                                    <v-spacer></v-spacer>
                                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                                    <v-btn color="primary" text @click.prevent="doFilters">Apply Filters</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </form>
                      </v-flex>
                      <v-flex xs12 class="mt-2">
                        <v-data-table
                          :headers="headers"
                          :items="items"
                          :options.sync="pagination"
                          :footer-props="{'items-per-page-options': itemsPerPage }"
                          :server-items-length="totalItems"
                          :loading="loading"
                          class="elevation-1"
                          :no-data-text="noDataText"
                        >
                          <template v-slot:item="row">
                            <tr>
                              <td>{{ row.item.insdRefNo }}</td>
                              <td>{{ row.item.name1 }}</td>
                              <td>{{ row.item.name2 }}</td>
                              <td>{{ row.item.address3 }}</td>
                              <td>{{ row.item.icNo }}</td>
                              <td>{{ row.item.roc }}</td>
                              <td style="margin: 0 auto">
                                <v-btn icon v-on="on" color="primary" text type="submit" @click.prevent="doSelectInsdRefNo(row.item)">
                                  <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-card-text>
          </v-card>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div xs12>
                  <v-icon>mdi-account-check</v-icon><span class="headerTitle">{{ labels.altInsuredTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap align-center>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altName1"
                            :label="labels.altName1"
                            :error-messages="errors.collect('altName1')"
                            data-vv-name="altName1"
                            :data-vv-as="labels.altName1"
                            v-validate="valAltName1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altName2"
                            :label="labels.altName2"
                            :error-messages="errors.collect('altName2')"
                            data-vv-name="altName2"
                            :data-vv-as="labels.altName2"
                            v-validate="'max:50'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-divider class="mt-3 mb-3"></v-divider>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="subheading font-weight-strong teal--text">{{ labels.mailingAddTitle }}</div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex lg12 md12 xs12>
                          <v-checkbox v-model="mainForm.sameInsdAddr" :label="labels.sameInsdAddr" @change="doAltSameAsInsd"></v-checkbox>
                        </v-flex>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altInsdAddr1"
                            :label="labels.altInsdAddr1"
                            :error-messages="errors.collect('altInsdAddr1')"
                            data-vv-name="altInsdAddr1"
                            :data-vv-as="labels.altInsdAddr1"
                            v-validate="'max:60'"
                            :disabled="mainForm.sameInsdAddr"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altInsdAddr2"
                            :label="labels.altInsdAddr2"
                            :error-messages="errors.collect('altInsdAddr2')"
                            data-vv-name="altInsdAddr2"
                            :data-vv-as="labels.altInsdAddr2"
                            v-validate="'max:60'"
                            :disabled="mainForm.sameInsdAddr"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altInsdAddr3"
                            :label="labels.altInsdAddr3"
                            :error-messages="errors.collect('altInsdAddr3')"
                            data-vv-name="altInsdAddr3"
                            :data-vv-as="labels.altInsdAddr3"
                            v-validate="valAltAddr"
                            :disabled="mainForm.sameInsdAddr"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 md6 xs12>
                          <v-text-field
                            v-model="mainForm.altInsdAddr4"
                            :label="labels.altInsdAddr4"
                            :error-messages="errors.collect('altInsdAddr4')"
                            data-vv-name="altInsdAddr4"
                            :data-vv-as="labels.altInsdAddr4"
                            v-validate="'max:60'"
                            :disabled="mainForm.sameInsdAddr"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-flex lg6 md6 xs12>
                        <v-text-field
                          v-model="mainForm.altPostCode"
                          :label="labels.altPostCode"
                          :error-messages="errors.collect('altPostCode')"
                          data-vv-name="altPostCode"
                          :data-vv-as="labels.altPostCode"
                          v-validate="valAltPostCode"
                          :disabled="mainForm.sameInsdAddr"
                          @change="fetchAddress(2)"
                        ></v-text-field>
                      </v-flex>
                      <v-dialog v-model="policy.saving" persistent width="300">
                        <v-card color="primary" dark>
                          <v-card-text>
                            Processing...
                            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-btn class="ma-1" color="error" dark :loading="policy.saving" @click.prevent="doExit">
            {{ labels.exit }}
            <v-icon dark right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn class="ma-1" color="info" dark :loading="policy.saving" @click.prevent="doSave">
            {{ labels.save }}
            <v-icon dark right>mdi-content-save</v-icon>
          </v-btn>
          <v-btn class="ma-1" color="primary" dark :loading="policy.saving" @click.prevent="doProceed">
            {{ labels.proceed }}
            <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showOccupationHelpList" width="1280px" persistent>
      <occupation-help-list @close="showOccupationHelpList = false" @assign-occupation="assignOccupation"></occupation-help-list>
    </v-dialog>
    <warning v-model="warnInsdRefNo2" @ok="doResetInsdRefNo">{{ warnInsdRefNoMsg2 }}</warning>

    <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
    <v-dialog v-model="showSanctionDialog" width="1280px">
      <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { POLICY_HEADER_TAB, POLICY_INSURED } from '@/store/types'
import { salutation, gender } from '@/const/underwriting'
import OccupationHelpList from '@/components/core/common/dialog/OccupationHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import { isEqual } from '@/utils/compare'

export default {
  data() {
    return {
      disableInsdRefNo: true,
      disableInsdRefAE: true,
      showInsdRefNo: false,
      totalItems: 0,
      labels: {
        clientType: 'Client Type',
        insuredTitle: 'Insured',
        insdRefNoAE: 'Insured Reference',
        insdRefNo: 'Insured Reference',
        individual: 'Individual',
        corporate: 'Corporate',
        titleName: 'Salutation',
        insdName1: 'Name 1',
        insdName2: 'Name 2',
        insdName3: 'Name 3',
        occupation: 'Occupation/Business',
        individualTitle: 'Individual',
        nationality: 'Nationality',
        icNo: 'NRIC / FIN / Passport No.',
        dob: 'Date of Birth',
        gender: 'Gender',
        corporateTitle: 'Corporate',
        roc: 'ROC / UEN',
        gstRegDate: 'GST Reg Date',
        gstRegNo: 'GST Reg No.',
        mailingAddTitle: 'Mailing Address',
        insdAddr1: 'Address 1',
        insdAddr2: 'Address 2',
        insdAddr3: 'Address 3',
        insdAddr4: 'Address 4',
        insdAddr5: 'State',
        insdAddr6: 'Country',
        postCode: 'Postal Code',
        contactInfoTitle: 'Contact Information',
        mobile: 'Mobile No.',
        telNo1: 'Home No.',
        telNo2: 'Office No.',
        fax: 'Fax No.',
        email: 'Email',
        altInsuredTitle: 'Alternate Insured',
        altName1: 'Name 1',
        altName2: 'Name 2',
        altName3: 'Name 3',
        altMailAddrTitle: 'Mailing Address',
        sameInsdAddr: 'Same as Insured',
        altInsdAddr1: 'Address 1',
        altInsdAddr2: 'Address 2',
        altInsdAddr3: 'Address 3',
        altInsdAddr4: 'Address 4',
        altInsdAddr5: 'State',
        altInsdAddr6: 'Country',
        altPostCode: 'Postal Code',
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save',
        proceed: 'Proceed'
      },
      filtersLabel: {
        insdRefNo: 'Insured Reference',
        name1: 'Name',
        icNo: 'IC No.',
        coRegNo: 'ROC / UEN'
      },
      filters: {
        insdRefNo: undefined,
        name1: undefined,
        icNo: undefined,
        coRegNo: undefined
      },
      headers: [
        { text: 'Insured Ref No.', align: 'left', value: 'insdRefNo' },
        { text: 'Name', value: 'name1' },
        { text: 'Name 2', value: 'name2' },
        { text: 'Street Name', value: 'address3' },
        { text: 'IC No.', value: 'icNo' },
        { text: 'ROC / UEN', value: 'roc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      mainForm: {
        clientType: undefined,
        insdRefNoAE: undefined,
        insdRefNo: undefined,
        insdStat: undefined,
        titleName: undefined,
        insdName1: undefined,
        insdName2: undefined,
        insdName3: undefined,
        insdAddr1: undefined,
        insdAddr2: undefined,
        insdAddr3: undefined,
        insdAddr4: undefined,
        insdAddr5: undefined,
        insdAddr6: undefined,
        postCode: undefined,
        telNo1: undefined,
        telNo2: undefined,
        mobile: undefined,
        fax: undefined,
        email: undefined,
        nationality: undefined,
        icNo: undefined,
        dob: undefined,
        gender: undefined,
        roc: undefined,
        gstRegDate: undefined,
        gstRegNo: undefined,
        altName1: undefined,
        altName2: undefined,
        altName3: undefined,
        sameInsdAddr: undefined,
        altInsdAddr1: undefined,
        altInsdAddr2: undefined,
        altInsdAddr3: undefined,
        altInsdAddr4: undefined,
        altInsdAddr5: undefined,
        altInsdAddr6: undefined,
        altPostCode: undefined
      },
      policy: {
        saving: false
      },
      nationalityList: [
        {
          label: 'SIN - SINGAPOREAN',
          value: 'SIN'
        },
        {
          label: 'SPR - SINGAPORE PR',
          value: 'SPR'
        },
        {
          label: 'OTH - OTHERS',
          value: 'OTH'
        }
      ],
      occupBusList: [],
      countryList: [],
      postalCodList: [],
      error: {
        insdRefNo: undefined,
        icNoRoc: undefined
      },
      warnInsdRefNo: false,
      warnInsdRefNo2: false,
      acceptInsdRefNo: false,
      warnInsdRefNoMsg: undefined,
      warnInsdRefNoMsg2: undefined,
      warnIcNoRoc: false,
      acceptIcNoRoc: false,
      warnIcNoRocMsg: undefined,
      initLoading: false,
      disabledInsured: undefined,
      readonlyIndividual: undefined,
      readonlyCorporate: undefined,
      showOccupationHelpList: false,
      clientTypeList: [],
      miscparams: {},
      chgNAPol: false, // 2020-11-17 LYT OS-564
      showErrorDialog: false,
      warnInsdAddr3: false, // 2021-03-19 LYT OS-702
      acceptInsdAddr3: false, // 2021-03-19 LYT OS-702
      warnInsdAddr3Msg: 'The street name field is required.', // 2021-03-19 LYT OS-702
      warnPostCode: false, // 2021-03-19 LYT OS-702
      acceptPostCode: false, // 2021-03-19 LYT OS-702
      warnPostCodeMsg: 'The postal code field is required.', // 2021-03-19 LYT OS-702
      insdIcUenMand: undefined, // 2021-03-19 LYT OS-702
      warnBlankIcNoRoc: false, // 2021-03-19 LYT OS-702
      acceptBlankIcNoRoc: false, // 2021-03-19 LYT OS-702
      warnBlankIcNoRocMsg: undefined, // 2021-03-19 LYT OS-702
      pagination: {
        sortDesc: [false],
        page: 1
      },
      panel1: [0]
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      if (this.polMaster.insdRefNoAE === null) {
        this.mainForm.insdRefNoAE = true
      } else {
        this.mainForm.insdRefNoAE = this.polMaster.insdRefNoAE
      }
      this.mainForm.insdRefNo = this.polMaster.insdRefNo
      if (this.polMaster.insdStat === null) {
        this.mainForm.insdStat = 'I'
      } else {
        this.mainForm.insdStat = this.polMaster.insdStat
      }
      this.mainForm.clientType = this.polMaster.clientType
      this.mainForm.titleName = this.polMaster.titleName
      this.mainForm.insdName1 = this.polMaster.insdName1
      this.mainForm.insdName2 = this.polMaster.insdName2
      this.mainForm.insdName3 = this.polMaster.insdName3
      this.mainForm.insdAddr1 = this.polMaster.insdAddr1
      this.mainForm.insdAddr2 = this.polMaster.insdAddr2
      this.mainForm.insdAddr3 = this.polMaster.insdAddr3
      this.mainForm.insdAddr4 = this.polMaster.insdAddr4
      this.mainForm.insdAddr5 = this.polMaster.insdAddr5
      this.mainForm.insdAddr6 = this.polMaster.insdAddr6
      this.mainForm.postCode = this.polMaster.postCode
      this.mainForm.telNo1 = this.polMaster.telNo1
      this.mainForm.telNo2 = this.polMaster.telNo2
      this.mainForm.mobile = this.polMaster.mobile
      this.mainForm.fax = this.polMaster.fax
      this.mainForm.email = this.polMaster.email
      this.mainForm.nationality = this.polMaster.nationality
      this.mainForm.occupation = this.polMaster.occupation
      if (this.mainForm.insdStat === 'I') {
        this.mainForm.icNo = this.polMaster.icNo
        this.mainForm.roc = ''
      } else {
        this.mainForm.icNo = ''
        this.mainForm.roc = this.polMaster.icNoROC
      }
      this.mainForm.dob = this.polMaster.dob
      this.mainForm.gender = this.polMaster.gender
      this.mainForm.gstRegDate = this.polMaster.gstRegDate
      this.mainForm.gstRegNo = this.polMaster.gstRegNo
      this.mainForm.altName1 = this.polMaster.altName1
      this.mainForm.altName2 = this.polMaster.altName2
      this.mainForm.altName3 = this.polMaster.altName3
      this.mainForm.sameInsdAddr = this.polMaster.sameInsdAddr
      this.mainForm.altInsdAddr1 = this.polMaster.altInsdAddr1
      this.mainForm.altInsdAddr2 = this.polMaster.altInsdAddr2
      this.mainForm.altInsdAddr3 = this.polMaster.altInsdAddr3
      this.mainForm.altInsdAddr4 = this.polMaster.altInsdAddr4
      this.mainForm.altInsdAddr5 = this.polMaster.altInsdAddr5
      this.mainForm.altInsdAddr6 = this.polMaster.altInsdAddr6
      this.mainForm.altPostCode = this.polMaster.altPostCode
      if (this.polMaster.insdRefNo === '' || this.polMaster.insdRefNo === null) {
        this.disableInsdRefAE = false
      }
      this.copymainForm = clone(this.mainForm)
      this.getPolType() // 2021-03-19 LYT OS-702
      // this.initPolInsured()
      // this.doGetClientType() AR: Replaced by CommonDataList OS-304
      // AR: Added OS-304 -- Start
      this.getCommonDataListDropDown('clientTypeList')
      // AR: Added OS-304 -- End
      await this.getCommonData('miscparams')
      await this.defaultClientType()
    },
    defaultClientType() {
      if (this.miscparams && (this.mainForm.insdRefNo !== '' || this.mainForm.insdRefNo !== null) && this.mainForm.clientType === '') {
        this.mainForm.clientType = this.miscparams.defInsClientType
      }
    },
    async initPolInsured() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.polInsdInit
      if (apiUrl) {
        this.initLoading = true
        const expand = {
          insdRefNo: this.mainForm.insdRefNo
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result.data.countryList) {
          this.$set(this, 'countryList', result.data.countryList)
        }
        if (result.data.occupBusList) {
          this.$set(this, 'occupBusList', result.data.occupBusList)
        }
        if (result.data.dob) {
          this.mainForm.dob = result.data.dob
        }
        if (result.data.gender) {
          this.mainForm.gender = result.data.gender
        }
        // if (result.data.chgNAPol) {
        //   this.disabledInsured = !result.data.chgNAPol
        // }
        // AR: Added OS-564
        // 2020-11-17 LYT OS-564
        this.chgNAPol = result.data.chgNAPol === null ? true : result.data.chgNAPol
        // if (this.mainForm.insdRefNoAE) {
        this.disabledInsured = !this.chgNAPol

        // if (this.disabledInsured === undefined) {
        //   this.disabledInsured = false
        // }
        // }

        // AR: Added OS-304
        if (this.miscparams && (this.mainForm.insdRefNo !== '' || this.mainForm.insdRefNo !== null) && this.mainForm.clientType === '') {
          this.mainForm.clientType = this.miscparams.defInsClientType
        }
        this.initLoading = false
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doValInsdStatus() {
      this.error.insdRefNo = undefined
      if (this.mainForm.insdRefNo !== undefined && this.mainForm.insdRefNo !== '') {
        const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.valInsdStatus
        if (apiUrl) {
          try {
            const expand = {
              insdRefNo: this.mainForm.insdRefNo,
              isAuto: this.mainForm.insdRefNoAE ? 'A' : 'E'
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data) {
              const { data } = result
              if (data.messages) {
                this.warnInsdRefNoMsg = data.messages[0].message
                this.disableInsdRefAE = false
                this.doWarnInsdRefNo()
              } else {
                this.warnInsdRefNoMsg = undefined
              }
              this.setInsured(data.data)
            }
          } catch (err) {
            if (this.mainForm.insdRefNoAE) {
              const { data } = err.response
              if (data) {
                this.error.insdRefNo = data.messages[0].message
              }
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      } else {
        this.doResetInsdRefNo()
      }
    },
    doWarnInsdRefNo() {
      if (!this.acceptInsdRefNo && this.warnInsdRefNoMsg !== undefined) {
        this.warnInsdRefNo = true
        return false
      } else {
        return true
      }
    },
    doAcceptInsdRefNo() {
      this.acceptInsdRefNo = true
    },
    doShowInsdRefNo() {
      this.showInsdRefNo = true
      this.$set(this, 'items', [])
      this.fetchData()
    },
    async doValDupInsdICNo() {
      // 2021-03-19 LYT OS-702
      this.doWarnBlankIcNoRoc()

      // 2020-11-16 LYT OS-564
      // if (!this.mainForm.insdRefNoAE) {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.valDupInsdICNO
      if (apiUrl) {
        var icNoRocLabel
        var icNoRocValue
        if (this.mainForm.insdStat === 'I') {
          icNoRocLabel = this.labels.icNo
          icNoRocValue = this.mainForm.icNo
        } else {
          icNoRocLabel = this.labels.roc
          icNoRocValue = this.mainForm.roc
        }
        if (icNoRocValue !== undefined && icNoRocValue !== null && icNoRocValue !== '') {
          const expand = {
            insdRefNo: this.mainForm.insdRefNo,
            icNo: icNoRocValue,
            label: icNoRocLabel,
            insdStat: this.mainForm.insdStat
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result
            // Show warning
            if (data.messages) {
              this.warnIcNoRocMsg = data.messages[0].message
              return this.doWarnIcNoRoc()
            }
          }
        } else {
          return true
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      // }
    },
    doWarnIcNoRoc() {
      if (!this.acceptIcNoRoc && this.warnIcNoRocMsg !== undefined && this.warnIcNoRocMsg !== '') {
        this.warnIcNoRoc = true
        return false
      } else {
        return true
      }
    },
    doAcceptIcNoRoc() {
      this.acceptIcNoRoc = true
    },
    // Find Insured Ref No. in Insured
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.insuredList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'items', data)
            } else {
              this.$set(this, 'items', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.insdRefNo = null
      this.filters.name1 = null
      this.filters.icNo = null
      this.filters.coRegNo = null
      this.fetchData()
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryInsdRefNoFilterForm').then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData()
        }
      })
    },
    doSelectInsdRefNo(data) {
      this.mainForm.insdRefNo = data.insdRefNo
      this.showInsdRefNo = false
      this.disableInsdRefAE = true
      this.doValInsdStatus()
    },
    setInsured(data) {
      this.mainForm.clientType = data.clientType
      this.mainForm.insdRefNo = data.insdRefNo
      this.mainForm.insdStat = data.clientGrp
      this.mainForm.titleName = data.titleName
      this.mainForm.insdName1 = data.name1
      this.mainForm.insdName2 = data.name2
      this.mainForm.insdName3 = data.name3
      this.mainForm.insdAddr1 = data.address1
      this.mainForm.insdAddr2 = data.address2
      this.mainForm.insdAddr3 = data.address3
      this.mainForm.insdAddr4 = data.address4
      this.mainForm.insdAddr5 = data.address5
      this.mainForm.insdAddr6 = data.address6
      this.mainForm.postCode = data.postalCode
      this.mainForm.telNo1 = data.telNo1
      this.mainForm.telNo2 = data.telNo2
      this.mainForm.mobile = data.telNo3
      this.mainForm.fax = data.telNo4
      this.mainForm.email = data.email
      if (data.clientGrp === 'I') {
        this.mainForm.icNo = data.icNo
        this.mainForm.gender = data.gender
        this.mainForm.roc = ''
      } else {
        this.mainForm.icNo = ''
        this.mainForm.gender = ''
        this.mainForm.roc = data.roc
      }
      this.mainForm.dob = data.dob
      this.mainForm.gstRegNo = data.gstRefNo
      this.mainForm.gstRegDate = data.gstRegDate
      // AR: OS-564
      // 2020-11-17 LYT OS-564
      this.chgNAPol = data.chgNAPol
      if (this.mainForm.insdRefNoAE) {
        this.disabledInsured = !data.chgNAPol
      }

      this.doAltSameAsInsd()
      this.resetSanction()
    },
    doAltSameAsInsd() {
      if (this.mainForm.sameInsdAddr) {
        this.mainForm.altInsdAddr1 = this.mainForm.insdAddr1
        this.mainForm.altInsdAddr2 = this.mainForm.insdAddr2
        this.mainForm.altInsdAddr3 = this.mainForm.insdAddr3
        this.mainForm.altInsdAddr4 = this.mainForm.insdAddr4
        this.mainForm.altInsdAddr5 = this.mainForm.insdAddr5
        this.mainForm.altInsdAddr6 = this.mainForm.insdAddr6
        this.mainForm.altPostCode = this.mainForm.postCode
      } else {
        this.mainForm.altInsdAddr1 = ''
        this.mainForm.altInsdAddr2 = ''
        this.mainForm.altInsdAddr3 = ''
        this.mainForm.altInsdAddr4 = ''
        this.mainForm.altInsdAddr5 = ''
        this.mainForm.altInsdAddr6 = ''
        this.mainForm.altPostCode = ''
      }
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    doReset() {
      this.doInit()
    },
    doProceed() {
      this.resetMessages()
      this.policy.saving = true
      this.doValidateAllWarn().then((result2) => {
        if (result2) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.doPolMasterSave().then((success) => {
                if (success) {
                  this.mainForm.insdRefNo = this.polMaster.insdRefNo
                  this.$store.commit(POLICY_HEADER_TAB, 2)
                  this.$router.push({ name: 'policyOtherDetails' })
                }
              })
            } else {
              this.policy.saving = false
              this.promptFieldCheck()
            }
          })
        } else {
          this.policy.saving = false
        }
      })
    },
    doSave() {
      this.resetMessages()
      this.policy.saving = true
      this.doValidateAllWarn().then((result2) => {
        if (result2) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.doPolMasterSave().then((success) => {
                if (success) {
                  this.mainForm.insdRefNo = this.polMaster.insdRefNo
                  this.disableInsdRefAE = true
                  this.$toast.success(this.successMessage())
                } else {
                  this.$toast.error(this.failedMessage())
                }
                this.policy.saving = false
              })
            } else {
              this.policy.saving = false
              this.promptFieldCheck()
            }
          })
        } else {
          this.policy.saving = false
        }
      })
    },
    async doPolMasterSave() {
      try {
        if (isEqual(this.mainForm, this.copymainForm) === true) {
          return true
        } else {
          this.$store.commit(POLICY_INSURED, this.mainForm)
          const saveResult = await this.$store.dispatch('savePolMasterInsured')
          if (saveResult) {
            this.copymainForm = clone(this.mainForm)
            return true
          } else {
            return false
          }
        }
      } catch (err) {
        return false
      }
    },
    async doValidateAllWarn() {
      let status = true
      // if (this.mainForm.insdRefNo === undefined || this.mainForm.insdRefNo === null || this.mainForm.insdRefNo === '') {
      //   const errMSg = {
      //     messages: [{ message: 'Insured Reference is mandatory.', type: 'ERROR' }]
      //   }
      //   this.message(errMSg)
      //   return false
      // }
      if (!this.acceptInsdRefNo) {
        if (!this.doWarnInsdRefNo()) {
          status = false
        }
      }
      if (status && !this.acceptInsdAddr3) {
        if (!this.doWarnInsdAddr3()) {
          status = false
        }
      }
      if (status && !this.acceptPostCode) {
        if (!this.doWarnPostCode()) {
          status = false
        }
      }
      if (status && !this.acceptBlankIcNoRoc) {
        if (!this.doWarnBlankIcNoRoc()) {
          status = false
        }
      }
      if (status && !this.acceptIcNoRoc) {
        status = await this.doValDupInsdICNo()
      }
      if (status === true && (this.mainForm.insdStat === undefined || this.mainForm.insdStat === null || this.mainForm.insdStat === '')) {
        const errMsg = {
          messages: [{ message: 'The Insured Status field is required', type: 'ERROR' }]
        }
        this.message(errMsg)
        this.fieldMessage(errMsg)
        status = false
      } // lcd_20210414: OS-756
      return status
    },
    assignOccupation(occupation) {
      this.mainForm.occupation = occupation
      this.showOccupationHelpList = false
    },
    doOccupation() {
      if (this.mainForm.occupation.value) {
        this.mainForm.occupation = this.mainForm.occupation.value
      }
    },
    successMessage() {
      return 'Policy record successfully saved.'
    },
    failedMessage() {
      return 'An unexpected error occured, failed saving policy record.'
    },
    async fetchAddress(caller) {
      if (caller === 1 && (this.mainForm.postCode === undefined || this.mainForm.postCode === null || this.mainForm.postCode === '')) {
        this.doWarnPostCode()
      } else {
        const apiUrl = this.$store.state.underwriting.policyHeaderSettings.menu.address
        if (apiUrl) {
          try {
            const expand = {
              postCode: caller === 1 ? this.mainForm.postCode : this.mainForm.altPostCode
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result
            if (data) {
              if (caller === 1) {
                // this.mainForm.insdAddr1 = data.add1 // Block No.
                // this.mainForm.insdAddr3 = data.add2 // Street Name
                // this.mainForm.insdAddr4 = data.add4 // Building Name
                this.mainForm.insdAddr1 = data.add1
                this.mainForm.insdAddr2 = data.add4
                this.mainForm.insdAddr3 = ''
                this.mainForm.insdAddr4 = ''
              } else {
                // this.mainForm.altInsdAddr1 = data.add1 // Block No.
                // this.mainForm.altInsdAddr3 = data.add2 // Street Name
                // this.mainForm.altInsdAddr4 = data.add4 // Building Name
                this.mainForm.altInsdAddr1 = data.add1
                this.mainForm.altInsdAddr2 = data.add4
                this.mainForm.altInsdAddr3 = ''
                this.mainForm.altInsdAddr4 = ''
              }
            }
            this.loading = false
          } catch (err) {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.notify(data)
              this.message(data)
            }
          }
        } else {
          this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doResetInsdRefNo() {
      this.mainForm.insdStat = 'I'
      this.mainForm.titleName = undefined
      this.mainForm.insdName1 = undefined
      this.mainForm.insdName2 = undefined
      this.mainForm.insdName3 = undefined
      this.mainForm.occupation = undefined
      this.mainForm.insdAddr1 = undefined
      this.mainForm.insdAddr2 = undefined
      this.mainForm.insdAddr3 = undefined
      this.mainForm.insdAddr4 = undefined
      this.mainForm.insdAddr5 = undefined
      this.mainForm.insdAddr6 = undefined
      this.mainForm.postCode = undefined
      this.mainForm.telNo1 = undefined
      this.mainForm.telNo2 = undefined
      this.mainForm.mobile = undefined
      this.mainForm.fax = undefined
      this.mainForm.email = undefined
      this.mainForm.icNo = undefined
      this.mainForm.gender = undefined
      this.mainForm.roc = undefined
      this.mainForm.dob = undefined
      this.mainForm.gstRegNo = undefined
      this.mainForm.gstRegDate = undefined
      this.mainForm.nationality = undefined

      // 2020-11-19 LYT OS-564
      // if (this.mainForm.insdRefNoAE === true) {
      //   this.disabledInsured = true
      // }
      this.disabledInsured = false
      this.disableInsdRefAE = false
      this.mainForm.insdRefNo = ''
      this.resetSanction()
    },
    showChangeInsuredWarn() {
      this.warnInsdRefNo2 = true
      this.warnInsdRefNoMsg2 = 'Are you sure want to change the insured record?'
    },
    doInsdRefNoAE() {
      if (this.mainForm.insdRefNoAE === true) {
        this.doResetInsdRefNo()
      }
    },
    doWarnInsdAddr3() {
      if (
        (this.mainForm.insdAddr3 === undefined || this.mainForm.insdAddr3 === null || this.mainForm.insdAddr3 === '') &&
        !this.acceptInsdAddr3 &&
        !this.polMaster.dri &&
        !this.miscparams.insdAddrMandRi
      ) {
        this.warnInsdAddr3 = true
        return false
      } else {
        return true
      }
    },
    doAcceptInsdAddr3() {
      this.acceptInsdAddr3 = true
    },
    doWarnPostCode() {
      if (
        (this.mainForm.postCode === undefined || this.mainForm.postCode === null || this.mainForm.postCode === '') &&
        !this.acceptPostCode &&
        !this.polMaster.dri &&
        !this.miscparams.insdAddrMandRi
      ) {
        this.warnPostCode = true
        return false
      } else {
        return true
      }
    },
    doAcceptPostCode() {
      this.acceptPostCode = true
    },
    async getPolType() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.polType
      if (apiUrl) {
        try {
          const expand = {
            polType: this.polMaster.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result

            this.insdIcUenMand = data.insdIcUenMand
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    doWarnBlankIcNoRoc() {
      this.warnBlankIcNoRocMsg = ''
      let icNoRoc = this.mainForm.insdStat === 'I' ? this.mainForm.icNo : this.mainForm.roc
      if (icNoRoc === undefined || icNoRoc === null || icNoRoc === '') {
        if (!this.insdIcUenMand) {
          if (this.mainForm.insdStat === 'I') {
            this.warnBlankIcNoRocMsg = 'The NRIC / FIN / Passport No. field is required.'
          } else {
            this.warnBlankIcNoRocMsg = 'The ROC / UEN field is required.'
          }
        }
      }

      if (!this.acceptBlankIcNoRoc && this.warnBlankIcNoRocMsg !== undefined && this.warnBlankIcNoRocMsg !== '') {
        this.warnBlankIcNoRoc = true
        return false
      } else {
        return true
      }
    },
    doAcceptBlankIcNoRoc() {
      this.acceptBlankIcNoRoc = true
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    },
    'mainForm.insdStat': function (value) {
      if (this.disabledInsured) {
        this.readonlyIndividual = true
        this.readonlyCorporate = true
      } else if (value === 'I') {
        this.mainForm.roc = ''
        this.mainForm.gstRegDate = undefined
        this.mainForm.gstRegNo = ''
        this.readonlyIndividual = false
        this.readonlyCorporate = true
      } else if (value === 'C') {
        this.mainForm.nationality = ''
        this.mainForm.icNo = ''
        this.mainForm.dob = undefined
        this.mainForm.gender = ''
        this.readonlyIndividual = true
        this.readonlyCorporate = false
      } else {
        this.readonlyIndividual = false
        this.readonlyCorporate = false
      }
    },
    disabledInsured: function (value) {
      if (value) {
        this.readonlyIndividual = true
        this.readonlyCorporate = true
      } else if (this.mainForm.insdStat === 'I') {
        this.readonlyIndividual = false
        this.readonlyCorporate = true
      } else if (this.mainForm.insdStat === 'C') {
        this.readonlyIndividual = true
        this.readonlyCorporate = false
      } else {
        this.readonlyIndividual = false
        this.readonlyCorporate = false
      }
    },
    'mainForm.insdRefNoAE': function (value) {
      this.disableInsdRefNo = value
      // 2020-11-17 LYT OS-564
      // if (value === false) {
      //   this.disabledInsured = false
      // } else {
      //   this.disabledInsured = true
      // }
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    valInsdRefNo() {
      if (this.mainForm.insdRefNoAE) {
        if (this.error.insdRefNo === undefined) {
          return 'max:20'
        } else {
          return 'max:20|valField:' + this.error.insdRefNo
        }
      } else {
        if (this.error.insdRefNo === undefined) {
          return 'required|max:20'
        } else {
          return 'required|max:20|valField:' + this.error.insdRefNo
        }
      }
    },
    valIcNo() {
      if (this.mainForm.insdStat === 'I') {
        if (this.insdIcUenMand) {
          return 'required|max:20|sanction:' + this.sanctionDocNoError
        } else {
          return 'max:20|sanction:' + this.sanctionDocNoError
        }
      } else {
        return 'max:20|sanction:' + this.sanctionDocNoError
      }
    },
    valRocNo() {
      if (this.mainForm.insdStat !== 'I') {
        if (this.insdIcUenMand) {
          return 'required|max:20'
        } else {
          return 'max:20'
        }
      } else {
        return 'max:20'
      }
    },
    valAltName1() {
      if (this.mainForm.sameInsdAddr) {
        return 'required|max:50'
      } else {
        return 'max:50'
      }
    },
    valAltAddr() {
      if (this.mainForm.altName1 !== null && this.mainForm.altName1 !== undefined && this.mainForm.altName1 !== '') {
        return 'required|max:60'
      } else {
        return 'max:60'
      }
    },
    valAltInsdAddr6() {
      if (this.mainForm.altName1 !== null && this.mainForm.altName1 !== undefined && this.mainForm.altName1 !== '') {
        return 'required'
      } else {
        return ''
      }
    },
    valAltPostCode() {
      if (this.mainForm.altName1 !== null && this.mainForm.altName1 !== undefined && this.mainForm.altName1 !== '') {
        return 'required|max:8'
      } else {
        return 'max:8'
      }
    },
    displayErrorDialog() {
      return this.messages
    },
    valInsdAddr3() {
      if (this.polMaster.dri) {
        return 'required|max:60'
      } else {
        if (this.miscparams.insdAddrMandRi) {
          return 'required|max:60'
        } else {
          return 'max:60'
        }
      }
    },
    valPostCode() {
      if (this.polMaster.dri) {
        return 'required|max:8'
      } else {
        if (this.miscparams.insdAddrMandRi) {
          return 'required|max:8'
        } else {
          return 'max:8'
        }
      }
    }
  },
  beforeMount() {
    this.doInit()
  },
  created() {
    // Local validator
    const valField = {
      getMessage: (field, args) => {
        if (args === void 0) args = []
        var errMsg = args[0]
        return errMsg
      },
      validate: (value, args) => {
        if (value) {
          if (args === void 0) args = []
          var errMsg = args[0]
          if (errMsg) {
            return false
          } else return true
        } else return true
      }
    }
    this.$validator.extend('valField', valField)
  },
  mixins: [MessageMixin, TableConst.default, commonAjaxMixin],
  components: {
    OccupationHelpList,
    SanctionPartialMatchList
  }
}
</script>
